<template>
    <div class="json-viewer" :class="{'has-error': error}">
        <span v-if="error" class="warning">&times;</span>
        <textarea cols="30" rows="10" class="form-control" :value="json" @input="parseJson" @blur="prettify"></textarea>
    </div>
</template>
<style>
.json-viewer {
    position: relative;
}

.json-viewer textarea {
    font-family: 'Fira Mono', monospace;
}

.json-viewer .warning {
    position: absolute;
    right: 20px;
    top: 0;
    color: red;
    font-size: 19px;
    font-weight: bold;
}
</style>
<script>
export default {
    name: 'json-viewer',
    props: ['value'],
    data() {
        return {
            json: '',
            error: false
        };
    },
    methods: {
        parseJson(event) {
            try {
                let parsed = JSON.parse(event.target.value);
                this.$emit('input', parsed);
                this.error = false;
            } catch (e) {
                this.error = true;
            }
            this.json = event.target.value;
        },
        prettify() {
            try {
                this.json = JSON.stringify(JSON.parse(this.json), null, '  ');
            } catch (e) {
                // ignore errors
            }
        }
    },
    watch: {
        value: {
            handler(val) {
                if (this.json && JSON.stringify(val) === JSON.stringify(JSON.parse(this.json))) {
                    // If it is same value then don't just prettify
                    return;
                }
                this.json = JSON.stringify(val, null, '  ');
            },
            deep: true
        }
    },
    mounted() {
        this.json = JSON.stringify(this.value, null, '  ');
    },
};
</script>


// WEBPACK FOOTER //
// resources/js/ui/JsonViewer.vue